import { UISubscriptionStatus } from "common/types";
import { Optional } from "common/utils/types";

import Banner from "client/common/components/content/Banner";
import { ModalStatus } from "client/common/types";
import { urls } from "client/routes";

import { SubscriptionForm, SubscriptionPaymentMethod } from "../types";
import { getSubscriptionPaymentIssueContent, shouldShowSubscriptionPaymentAlert } from "../utils";

type SubscriptionPaymentBannerProps = {
  subscription: {
    id: number;
    visible_status: UISubscriptionStatus;
    payment_method: Optional<SubscriptionPaymentMethod>;
  };
  className?: string;
};

/**
 * Announces a payment problem on the Autoship itself, so a client sees it without opening
 * one of the forms it blocks. Renders nothing when there is no problem to announce.
 *
 * Routed to the payment form rather than opening it in place so the list and the detail page
 * share one implementation.
 */
const SubscriptionPaymentBanner = ({ subscription, className }: SubscriptionPaymentBannerProps) => {
  if (!shouldShowSubscriptionPaymentAlert(subscription)) {
    return null;
  }

  const { bannerMessage, actionLabel } = getSubscriptionPaymentIssueContent(
    subscription.payment_method,
  );

  return (
    <Banner inline={true} variant="danger" className={className}>
      <Banner.Text
        label={bannerMessage}
        action={{
          children: actionLabel,
          dest: urls.subscriptions.detail({
            params: { id: subscription.id },
            search: {
              form: SubscriptionForm.UpdatePayment,
              visible: ModalStatus.Open,
            },
          }),
        }}
      />
    </Banner>
  );
};

export default SubscriptionPaymentBanner;
